module.exports = __webpack_public_path__ + "img/psbc_hLogo.c39e70d5.png";